import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';
import GEOInput from './GEOInputFile/GEOInputFileUpload';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const GEOFiles = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const getData = useCallback(() => {
		// dispatch(GetTemplates());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const [value, setValue] = React.useState('1');

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Page className={classes.root} title="RET Tools">
			<Header module="RET Tools" view="GEO Input Export" />
			<GEOInput className={classes.content} />
		</Page>
	);
};

export default GEOFiles;
